// extracted by mini-css-extract-plugin
module.exports = {"NoData":"NoData_NoData__jxgyD","content":"NoData_content__FauZb","msg":"NoData_msg__1Rexo","error":"NoData_error__1PGlp"};